import { useState } from "react";
import {
  Container,
  CssBaseline,
  Box,
  Typography,
  TextField,
  Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../hooks/redux-hooks";
import { updateDriverById } from "../slices/authSlice";
import {
  showNotification,
  NotificationType,
} from "../slices/notificationSlice";
import { useNavigate, Navigate } from "react-router-dom";

const DriverChangePassword = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const driverInfo = useAppSelector((state) => state.auth.driverInfo);

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");

  if (!driverInfo) {
    return <Navigate replace to={"/driver-login"} />;
  }

  const handleSubmit = async () => {
    setError("");

    if (!oldPassword || !newPassword || !confirmPassword) {
      setError(t("pleaseInputAllPasswords"));
      return;
    }

    if (newPassword.length < 6) {
      setError(t("passwordTooShort"));
      return;
    }

    if (newPassword !== confirmPassword) {
      setError(t("passwordsNotMatch"));
      return;
    }

    try {
      const result = await dispatch(
        updateDriverById({
          user_id: +driverInfo.uid,
          oldPassword,
          newPassword,
        })
      ).unwrap();
      
      if (result) {
        dispatch(
          showNotification({
            message: t("passwordChangeSuccess"),
            type: NotificationType.Success,
          })
        );
        // 修改成功后返回上一页
        navigate(-1);
      }
    } catch (error: any) {
      setError(error?.message || t("passwordChangeFailed"));
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <Container maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{
          mt: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography variant="h5" sx={{ mb: 3 }}>
          {t("resetPassword")}
        </Typography>
        <TextField
          margin="normal"
          required
          fullWidth
          type="password"
          id="oldPassword"
          label={t("currentPassword")}
          name="oldPassword"
          autoFocus
          value={oldPassword}
          onChange={(e) => setOldPassword(e.target.value)}
          error={!!error}
        />
        <TextField
          margin="normal"
          required
          fullWidth
          type="password"
          id="newPassword"
          label={t("newPassword")}
          name="newPassword"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          error={!!error}
        />
        <TextField
          margin="normal"
          required
          fullWidth
          type="password"
          id="confirmPassword"
          label={t("confirmPassword")}
          name="confirmPassword"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          error={!!error}
          helperText={error}
        />
        <Button
          fullWidth
          variant="contained"
          sx={{ mt: 3 }}
          onClick={handleSubmit}
        >
          {t("btnConfirm")}
        </Button>
        <Button
          fullWidth
          variant="outlined"
          sx={{ mt: 2 }}
          onClick={handleBack}
        >
          {t("btnBack")}
        </Button>
      </Box>
    </Container>
  );
};

export default DriverChangePassword;